import { joinClasses } from 'utils/componentStyles/style.utils';
import {
  getWeatherMapFlexDirectionClass,
  getWeatherMapPanelAxisClass,
} from '../../../../utils/weatherMapLayout.utils';

const StaticWeatherMapLayout = ({
  orientation,
  mapContent,
  panelContent,
  mapDefaultSize,
  panelDefaultSize,
  mapAriaLabel,
  panelAriaLabel,
  containerClassName,
  mapClassName,
  panelClassName,
}) => {
  const isStacked = orientation === 'vertical';
  const panelAxisClass = getWeatherMapPanelAxisClass(orientation);

  return (
    <div
      className={joinClasses(
        'weather-map-resizable-layout d-flex w-100 min-h-0 min-w-0',
        getWeatherMapFlexDirectionClass(orientation),
        containerClassName,
      )}
      data-resizable="false"
      data-weather-map-layout={orientation}
    >
      <section
        aria-label={mapAriaLabel}
        className={joinClasses(
          'd-flex min-w-0 flex-shrink-0 flex-column',
          !isStacked && 'min-h-0',
          panelAxisClass,
          mapClassName,
        )}
        style={isStacked ? undefined : { flexBasis: mapDefaultSize }}
      >
        {mapContent}
      </section>

      <aside
        aria-label={panelAriaLabel}
        className={joinClasses(
          'd-flex min-w-0 flex-shrink-0 flex-column',
          !isStacked && 'min-h-0',
          panelAxisClass,
          panelClassName,
        )}
        style={isStacked ? undefined : { flexBasis: panelDefaultSize }}
      >
        {panelContent}
      </aside>
    </div>
  );
};

export default StaticWeatherMapLayout;
